import React from 'react'

export default ({ name, image, content, profile, index, socialUrls: { fbUrl, whatsAppUrl, xapoUrl, linkedin, twitterUrl, instagramUrl } }) => {
  return <>
    {index === 0 && <div className="col-lg-1 col-md-12"></div>}
    <div className="col-lg-5 col-md-6 col-sm-12">
      <div className="team-wrapper">
        <div>
          <img src={image} alt={profile} />
        </div>
        <div className="content-wrapper">
          <h4 className="mt-0 mb-0 mw-100">{name}</h4>
          <div className="profile">{profile}</div>
          <p className="content">{content}</p>
          <div className="social-links">
            {
              fbUrl &&
              <a href={fbUrl} target="_blank" rel="noopener noreferrer"><img src="/img/iconfinder_Circled_Facebook_color.png" alt="Facebook" /></a>
            }
            {
              whatsAppUrl &&
              <a href={whatsAppUrl} target="_blank" rel="noopener noreferrer"><img src="/img/iconfinder_Circled_Whatsapp_color.png" alt="WhatsApp" /></a>
            }
            {
              xapoUrl &&
              <a href={xapoUrl} target="_blank" rel="noopener noreferrer"><img src="/img/xapo.png" alt="Twitter" /></a>
            }
            {linkedin &&
              <a href={linkedin} target="_blank" rel="noopener noreferrer"><img src="/img/iconfinder_Circled_Linkedin.png" alt="Linkedin" /></a>
            }
            {twitterUrl &&
              <a href={twitterUrl} target="_blank" rel="noopener noreferrer"><img src="/img/iconfinder_Circled_Twitter.png" alt="Twitter" /></a>
            }
            {instagramUrl &&
              <a href={instagramUrl} target="_blank" rel="noopener noreferrer"><img src="/img/iconfinder_Circled_Instagram.png" alt="Instagram" /></a>
            }
          </div>
        </div>
      </div>
    </div>
    {index !== 0 && <div className="col-lg-1 col-md-12"></div>}
  </>
}
